import { FC } from 'react';

import { SlideoutCommonProps } from 'components/design-system/Slideout';
import { pageRoutes } from 'lib/routes';
import { extendUrlByQueries } from 'lib/url_helpers';
import { PurchaseRequestOffer } from 'types';

import { ListingItem } from './components/ListingItem';
import { PurchaseRequestSlideout } from './PurchaseRequestSlideout';

type SubmittedOffersSlideoutProps = {
  requestOffers: PurchaseRequestOffer[];
} & SlideoutCommonProps;

export const SubmittedOffersSlideout: FC<SubmittedOffersSlideoutProps> = ({ requestOffers, ...props }) => (
  <PurchaseRequestSlideout title='Your submissions' {...props}>
    <div className='d-flex flex-column w-100 align-items-center'>
      {requestOffers.map(offer => {
        const customUrl = extendUrlByQueries(pageRoutes.sellerDashboard, { offerId: offer.id });

        return (
          <ListingItem
            offerStatus={offer.status}
            customUrl={customUrl}
            listing={offer.listing}
            key={offer.listing.id}
          />
        );
      })}
    </div>
  </PurchaseRequestSlideout>
);
